const api = {
  GET_LIST_MERCHANT_API: '/index.php?r=api/v1/system_log/service-log/merchant-api',
};

export default api;
